import * as $ from "jquery";

import { clearMenu, ISelectItem, populateMenu } from "./utility";

const SESSIONCAMPUS = "lastcampusTM";

export class ChooseSchool {
    $states: JQuery;
    $statehidden: JQuery;
    $menu: JQuery; // list of school
    $input: JQuery;
    $school: JQuery;
    $campuses: JQuery;

    constructor() {
        this.$states = $("#SchoolState");
        this.$school = $("#School");
        this.$menu = $("#schooldropdownarea");
        this.$input = $("#schooltextarea");
        this.$campuses = $("#CampusID");
        this.$statehidden = $("#SchoolStateHidden");
        const self = this;

        // Populates school options and toggles field visibility
        this.$states.on("change", function () {
            self.stateChanged();
            sessionStorage.removeItem(SESSIONCAMPUS);
        });

        // Toggles campus input visibility
        this.$campuses.on("change", function () {
            const campus = <string> $(this).val();

            // save the campus in session storage
            sessionStorage.setItem(SESSIONCAMPUS, campus);

            const showSchoolText = campus.length>0 && campus === "-1";
            self.showSchoolInput(showSchoolText);
        });

        // if we're using the back button then try to restore it
        const selectedStateHidden = <string> this.$statehidden.val();
        let selectedState = <string> this.$states.val();
        //console.log("Hidden state: " + selectedStateHidden);
        //console.log("Selected state: " + selectedState);
        if (selectedStateHidden && !selectedState) {
            this.$states.val(selectedStateHidden);
        }

        // repopulate based on the state
        const selState = self.stateChanged();
        if (selState && selState !== "??") {
            //console.log("State pre-selected: " + selState);
            const campusIDHidden = <string> $("#CampusIDHidden").val();
            if (campusIDHidden) {
                self.populateCampusList(selState, (data) => {
                    self.$campuses.val(campusIDHidden);
                    if (campusIDHidden === "-1") {
                        self.showSchoolInput(true);
                    }
                });
            }
        } else {
            this.$campuses.prop("disabled", true);
        }
    }

    stateChanged(): string {
        const state = <string> this.$states.val();
        this.$statehidden.val(state);

        if (state) {
            this.getState(state);
        } else {
            this.showSchoolInput(false);
            this.showCampusSelect(true);
            clearMenu(this.$campuses, "- Select -");
            this.$campuses.prop("disabled", true);
        }

        return state;
    }

    getState(state: string) {
        const self = this;
        // If outside US
        if (state === "??") {
            self.showSchoolInput(true);
            self.showCampusSelect(false);
        } // If another state
        else {
            clearMenu(this.$campuses, "- Select -");
            self.showSchoolInput(false);
            self.populateCampusList(state, (data: Array<ISelectItem>) => {
                const lastCampus = sessionStorage.getItem(SESSIONCAMPUS);
                if (lastCampus && data.find((el) => el.Value === lastCampus)) {
                    self.$campuses.val(lastCampus);
                    if (lastCampus === "-1") {
                        self.showSchoolInput(true);
                    }
                }
            });
            this.showCampusSelect(true);
            this.$campuses.prop("disabled", false);
        }
    }

    private populateCampusList(
        state: string,
        postpopulate: (data: Array<ISelectItem>) => void,
    ) {
        const self = this;
        $.getJSON(
            "/register/campusinstate/" + state,
            {},
            function (data: Array<ISelectItem>, textStatus) {
                populateMenu(self.$campuses, data, "- Select -");
                if (data) {
                    postpopulate(data);
                }
            },
        );
    }

    showCampusSelect(show: boolean) {
        this.$menu.toggleClass("show-field", show);
    }

    // Show/hide the school input field
    showSchoolInput(show: boolean) {
        if (show) {
            this.$input.addClass("show-field");
            const self = this;
            setTimeout(function () {
                self.$school.trigger("focus");
            }, 100);
        } else {
            this.$input.removeClass("show-field");
        }
    }
}
